











import { Component, Vue } from 'vue-property-decorator';
import DefaultAppLayout from '@/layouts/app/DefaultAppLayout.vue';
import LoginAppLayout from '@/layouts/app/LoginAppLayout.vue';
import { IdentitiesConnector } from '@/connectors/identity/identities.connector';
import MpGlobalDialog from '@/components/wrappers/mp-global-dialog/MpGlobalDialog.vue';
import MpGlobalSnackbar from '@/components/wrappers/mp-global-snackbar/MpGlobalSnackbar.vue';

@Component({
  components: {
    MpGlobalSnackbar,
    MpGlobalDialog,
    DefaultAppLayout,
    LoginAppLayout
  }
})
export default class App extends Vue {
  identityConnector = new IdentitiesConnector();

  get layout() {
    return this.$store.state.application.layout;
  }

  async created() {
    let isAuthenticated = false;

    try {
      isAuthenticated = await this.identityConnector.checkAuthentication();

      if (isAuthenticated) {
        await this.$store.dispatch('user/initMetadata');
        await this.$store.dispatch('application/fetchConfig');
        // await store.dispatch('metadata/initAll');
      }
    } catch {
      await this.$store.dispatch('user/logout');
    }
  }
}
